import { useMemo } from 'react';
import { useAuthService, useRegistrationApiProvider, useRegistrationStorage } from '../api';
import { RegistrationService } from './registrationService';

export const useRegistrationService = (): RegistrationService => {
  const api = useRegistrationApiProvider();
  const registrationStorage = useRegistrationStorage();
  const authService = useAuthService();

  return useMemo(() => new RegistrationService(api, registrationStorage, authService), [api, registrationStorage, authService]);
};
